import ReactJson from "react-json-view";
import { Card, useMantineTheme } from "@mantine/core";

const JsonViewer = ({ data, name = "data", fontSize = 12, collapsed = 1 }) => {
  const theme = useMantineTheme();
  return (
    // <Card withBorder mt="md" style={{ padding: "5px", margin: "0px" }}>
    <ReactJson
      src={data}
      name={name}
      theme={theme.colorScheme === "dark" ? "monokai" : "rjv-default"}
      collapsed={collapsed}
      style={{
        fontSize: `${fontSize}px`,
        padding: 0,
        margin: 0,
        border: "none",
        backgroundColor: "transparent",
      }}
    />
    // </Card>
  );
};

export default JsonViewer;
